import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap"
import { AvForm } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import FileUpload from "components/Common/file-upload/file-upload";
 
function AreaModal({ modal, toggle }) {
    const [loading, setLoading] = useState(false)
    const [mediaIds, setMediaIds] = useState([])

    const handleValidSubmit = (_, values) => {

    }
    const updatedAttachment = (attachments, type) => {
        try {
            setMediaIds([...mediaIds, ...attachments])
        toast.success(`Upload Sheet Successfully`)
        toggle()
        } catch (error) {
            toast.success(`Upload Sheet Faild`)
   
        }
    };
    const deleteAttachment = (Items, type) => {
        let updatedMedia = mediaIds.filter(item => item.id != Items[0].id)
        setMediaIds(updatedMedia)

    };

    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>
                <ModalHeader toggle={toggle}>
                    Upload Excel Sheet
                 </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}>
                            <FileUpload 
                                accept='.xlsx,.csv,.xls'
                                label='Upload Excel sheet'
                                attachmentType='media_id'
                                setUpload={()=> {}}
                                attachmentData={mediaIds}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}

                            />
                        </Col>
                    </Row>

                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0">
                <Row>
                    <Col>
                    <button
                        onClick={toggle}
                        type='button'
                        className='btn btn-secondary'>

                        Cancel
                        </button>
                    {/* <button
                        type='submit'
                        disabled={loading ? true : false}
                        className='btn btn-success'>
                        Submit
                        </button> */}
                        </Col>
                    </Row>
                </ModalFooter>
            </AvForm>
        </Modal>

    )
}

export default AreaModal
